<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('saleDayBook.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('saleDayBook.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('saleDayBook.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('yearlyPaymentList.branchName')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('saleDayBook.invoiceNumber') }}</label>
                      <input
                        type="text"
                        style="width: 100%"
                        class="form-control"
                        v-model.number="model.inv_number"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('saleDayBook.date')
                      }}</label>
                      <a-range-picker
                        style="width: 100%"
                        v-model="model.date_range"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                      />
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        class="ml-2 mr-2"
                        outline
                        color="success"
                        :waiting="exporting"
                        @click.prevent="exportExcel"
                        >{{ $t('excel') }}</ts-button
                      >
                      <ts-button
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('saleDayBook.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'saleDayBook',
  data () {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      invoices: [],
      model: {
        branch_id: null,
        inv_number: null,
        date_range: [moment(), moment()]
      }
    }
  },
  created () {
    this.fetchResource()
  },
  methods: {
    ...mapActions('reportPayment', [
      'getBranch',
      'saleDayBook',
      'saleDayBookExcel'
    ]),
    async fetchResource () {
      this.loading = true
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = this.$store.state.authUser.default_branch_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()

      this.saleDayBookExcel(this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'.indexOf('filename')]
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    preview () {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.saleDayBook(this.model)
        .then(response => {
          this.src = response.url
          this.when
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
